import List from "@/components/list";
const Table = args => {
  const AccountTableConfig = args.props.mqInfoType == 6 ? [
    {
      label: "联络员姓名",
      prop: "toUserName"
    },
    {
      label: "联络员手机号码",
      prop: "toUserMobile"
    },
    {
      label: "管理的学员名单",
      prop: "classEnrollNames"
    },
    {
      label: "消息内容",
      prop: "mqContent",
      showOverflowTooltip: true,
      minWidth: 300
    }
  ] : [
    {
      label: "姓名",
      prop: "toUserName"
    },
    {
      label: "手机号码",
      prop: "toUserMobile"
    },
    {
      label: "工作单位",
      prop: "deptName"
    },
    {
      label: "单位及职务",
      prop: "unitPosition"
    },
    {
      label: "消息内容",
      prop: "mqContent",
      showOverflowTooltip: true,
      minWidth: 300
    }
  ];
  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
